import {gql} from 'graphql-request';

import {graphqlClient} from '@/services/graphqlClient';
import type {
  CreateEventInput,
  CreateEventMutation,
} from '@/services/graphqlHooks';

gql`
  query GetEventsByPairingId($input: GetEventsByPairingIdInput!) {
    getEventsByPairingId(input: $input) {
      id
      date
      eventSubType
      content
      pairingId
      type
      createdBy
      isSharedToAuthorizedRelative
    }
  }

  query GetEventById($eventId: ID!) {
    getEventById(id: $eventId) {
      id
      date
      eventSubType
      content
      pairingId
      type
      createdBy
      isSharedToAuthorizedRelative
    }
  }

  query GetEventsByDateRange($input: GetEventsWithDateRangeInput!) {
    getEventsByDateRange(input: $input) {
      id
      date
      eventSubType
      content
      pairingId
      type
      createdBy
      isSharedToAuthorizedRelative
    }
  }

  mutation CreateEvent($input: CreateEventInput!) {
    createEvent(input: $input) {
      pairingId
      id
      date
    }
  }

  mutation UpdateEvent($input: UpdateEventInput!) {
    updateEvent(input: $input) {
      pairingId
      id
    }
  }

  mutation DeleteEvent($id: ID!) {
    deleteEvent(id: $id) {
      pairingId
      id
    }
  }
`;

type CreateEventsResponse = Record<string, CreateEventMutation['createEvent']>;
type CreateEventsVariables = Record<string, CreateEventInput>;

function createEventsVariables(inputs: CreateEventInput[]) {
  if (!inputs.length) {
    throw new Error('At least one event input is required.');
  }

  return Object.fromEntries(
    inputs.map((input, index) => [`input${index}`, input])
  );
}

function createEvents(inputs: CreateEventInput[]) {
  const mutation = `
    mutation CreateEvents(
      ${inputs
        .map((_, index) => `$input${index}: CreateEventInput!`)
        .join('\n')}
    ) {
      ${inputs
        .map(
          (_, index) => `
            event${index}: createEvent(input: $input${index}) {
              pairingId
              id
              date
            }
          `
        )
        .join('\n')}
    }
  `;

  return graphqlClient.request<CreateEventsResponse, CreateEventsVariables>(
    mutation,
    createEventsVariables(inputs)
  );
}

export const createEventsMutationOptions = {
  mutationKey: ['CreateEvents'],
  mutationFn: createEvents,
};
